import { render } from "./InputSplit.vue?vue&type=template&id=6a40d107&ts=true"
import script from "./InputSplit.vue?vue&type=script&lang=ts"
export * from "./InputSplit.vue?vue&type=script&lang=ts"

import "./InputSplit.vue?vue&type=style&index=0&id=6a40d107&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__